import { api_ } from '@shared/plugIn/axios';

/**
 * 담당 지도사 변경 (관리자 전용).
 *
 * 전용 엔드포인트 `PATCH admin/fevent/:id/change-worker` 하나만 쓴다 — 서버가 fevent·bugo·member를
 * 한 번에 재귀속하고 새 지도사의 상조로 bugoBrand까지 정렬한다(검증·감사 로그 포함).
 * **백엔드 반영 요청 상태** — docs/fevent-change-worker-spec.md
 * 구서버(404)에는 제네릭 라우트 폴백을 두지 않는다: 관리자 기능이라 "현재 사용할 수 없음"
 * 안내로 충분하고, 프론트가 3개 컬렉션을 순차로 만지는 부분 실패 경로를 만들지 않기 위해서다.
 */

/** 전용 엔드포인트 body */
export interface FeventChangeWorkerDto {
  userId: string;
  /** 상조가 바뀔 때 새 상조의 행사 상조(멀티 브랜드) 인덱스. 생략=해제 */
  bugoBrandAgencyIndex?: number;
}

export interface FeventChangeWorkerResult {
  updated?: { bugos?: number; members?: number };
  bugoBrandChanged?: boolean;
}

/** 엔드포인트 미배포(404) — 화면은 "현재 사용할 수 없음"으로 안내 */
export class ChangeWorkerUnavailableError extends Error {
  constructor() {
    super('change-worker endpoint unavailable');
  }
}

export const isChangeWorkerUnavailable = (err: unknown) =>
  (err as { response?: { status?: number } })?.response?.status === 404;

export const changeFeventWorkerEndpointUrl = (feventId: string) =>
  `admin/fevent/${feventId}/change-worker`;

export const changeFeventWorker = async (
  feventId: string,
  dto: FeventChangeWorkerDto,
): Promise<FeventChangeWorkerResult> => {
  try {
    const { data } = await api_.patch<FeventChangeWorkerResult>(
      changeFeventWorkerEndpointUrl(feventId),
      dto,
    );
    return {
      updated: data?.updated,
      bugoBrandChanged: data?.bugoBrandChanged,
    };
  } catch (err) {
    if (isChangeWorkerUnavailable(err)) throw new ChangeWorkerUnavailableError();
    throw err;
  }
};
